import { render } from "./create-account.vue?vue&type=template&id=4bbfa56e&scoped=true"
import script from "./create-account.vue?vue&type=script&lang=js"
export * from "./create-account.vue?vue&type=script&lang=js"

import "./create-account.vue?vue&type=style&index=0&id=4bbfa56e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbfa56e"]])

export default __exports__